import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export function NotifyMeButton({ plant, className = "", size = "default" }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || sending) return;
    setSending(true);
    try {
      await api.post("/waitlist", { email, role: "notify", plant_slug: plant?.slug });
      setSent(true);
      toast.success(`We'll notify you when ${plant?.name || "this plant"} is ready.`);
      setTimeout(() => { setOpen(false); setSent(false); setEmail(""); }, 1500);
    } catch {
      toast.error("Something went wrong. Try again?");
    } finally {
      setSending(false);
    }
  };

  const buttonBase =
    size === "large"
      ? "w-full bg-[var(--gu-primary)] text-[var(--gu-bg)] py-4 overline hover:bg-[var(--gu-primary)]/90 transition-colors"
      : "overline text-[var(--gu-primary)] border-b border-[var(--gu-primary)] pb-1 hover:text-[var(--gu-accent)] hover:border-[var(--gu-accent)] transition-colors";

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        data-testid={`notify-me-${plant?.slug || "generic"}`}
        className={`${buttonBase} ${className}`}
      >
        Notify me when this drops
      </button>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid={`notify-me-form-${plant?.slug || "generic"}`}
      className={`w-full ${className}`}
    >
      {sent ? (
        <div className="font-display italic text-[var(--gu-primary)] py-3">
          Thank you. We'll write when this leaf is ready.
        </div>
      ) : (
        <div className="flex items-end border-b border-[var(--gu-border)] focus-within:border-[var(--gu-primary)] transition-colors">
          <input
            type="email"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your email"
            className="flex-1 bg-transparent outline-none border-0 py-2 text-base"
          />
          <button
            type="submit"
            disabled={sending}
            className="overline text-[var(--gu-primary)] pl-4 pb-2 hover:text-[var(--gu-accent)] transition-colors disabled:opacity-50"
          >
            {sending ? "…" : "Send →"}
          </button>
        </div>
      )}
    </form>
  );
}
